<template>
  <section
    :class="[
      `bundle-row-item-bl__wrapper`,
      isBestValue && 'bundle-row-item-bl__wrapper--best-value',
    ]"
  >
    <template>
      <div v-if="isBestValue" class="bundle-row-item-bl--best-value-square"></div>
      <div class="bundle-row-item-bl__bundle-name">{{ bundleName }}</div>
      <div
        @click="updateSelectedBundle(bundle)"
        :class="[
          'bundle-row-item-bl',
          'bundle-row-item-bl--padding-40',
          isBestValue && 'bundle-row-item-bl--best-value',
        ]"
      >
        <div
          :class="[
            'bundle-row-item-bl__price-wrapper',
            isBestValue && 'bundle-row-item-bl__price-wrapper--best-value',
          ]"
        >
          <div class="bundle-row-item-bl__price">
            {{ `$${price}` }}
          </div>
        </div>
        <div
          :class="
            isBestValue
              ? `bundle-row-item-bl__item-background`
              : `bundle-row-item-bl__item-background--transparent`
          "
        >
          <div class="bundle-row-item-bl__radio-wrapper">
            <RadioButton :isSelected="isSelected" />
          </div>
          <div class="bundle-row-item-bl__content">
            <div class="bundle-row-item-bl__included">
              <div
                v-if="includesPremium"
                class="bundle-row-item-bl__included__item bundle-row-item-bl__included__premium"
              >
                <span class="bundle-row-item-bl__included__item__title">Premium</span>
                <span class="bundle-row-item-bl__included__item__subtitle">SUBSCRIPTION</span>
              </div>
              <div
                v-if="includesSkillDive"
                class="bundle-row-item-bl__included__item bundle-row-item-bl__included__skill-dive"
              >
                <img :src="skillDiveLogoBadge" width="193px" />
              </div>
              <div
                class="bundle-row-item-bl__included__item bundle-row-item-bl__included__certification"
                v-if="includesCertification"
              >
                <span class="bundle-row-item-bl__included__item__subtitle">1 INE SECURITY</span>
                <span class="bundle-row-item-bl__included__item__title">Certification</span>
              </div>
              <div
                v-if="includesFundAnnual"
                class="bundle-row-item-bl__included__item bundle-row-item-bl__included__fund-annual"
              >
                <span class="bundle-row-item-bl__included__item__title">Fundamentals Annual</span>
                <span class="bundle-row-item-bl__included__item__subtitle">SUBSCRIPTION</span>
              </div>
            </div>
            <div class="bundle-row-item-bl__hr"></div>
            <div class="bundle-row-item-bl__details">
              <PlanListItemDetails :plan="bundle" />
            </div>
            <div v-if="notIncludesSkillDive" class="bundle-row-item-bl__bottom-content">
              <div class="bundle-row-item-bl__not-included">*Skill Dive Not Included</div>
            </div>
            <div v-if="oneSkillDiveIncluded" class="bundle-row-item-bl__bottom-content">
              <div class="bundle-row-item-bl__not-included">*Includes 1 Skill Dive Focus Area</div>
            </div>
          </div>
        </div>
        <div
          :class="[`bundle-row-item-bl__footer`, isBestValue && 'bundle-row-item-bl__footer--best']"
        >
          <div v-if="isBundle1" class="bundle-row-item-bl__footer__bundle1">
            <div>Train, Practice, Assess, & Certify</div>
            <div class="bundle-row-item-bl__footer--highlighted">YOU SAVE $749</div>
          </div>
          <div v-if="isBundle2" class="bundle-row-item-bl__footer__bundle1">
            <div class="bundle-row-item-bl__footer--highlighted">YOU SAVE $650</div>
          </div>
          <div v-if="isBundle3" class="bundle-row-item-bl__footer__bundle1">
            <div class="bundle-row-item-bl__footer--small">
              Introductory Content
              <span class="bundle-row-item-bl__footer--purple">Free eJPT and ICCA voucher</span>
            </div>
            <div class="bundle-row-item-bl__footer--highlighted">YOU SAVE $100</div>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { updateCart } from '@/helpers/mixins'
import PlanListItemDetails from '@/components/plan-item-card/PlanListItemDetails.vue'
import CONSTANTS from '@/constants'
import RadioButton from '@/components/shared/RadioButton.vue'
import skillDiveLogo from '@/assets/images/hero-section/skill-dive/skill-dive-logo.png'

const {
  PLANS,
  PREMIUM_PLANS,
  BLACK_FRIDAY_PRODUCT_BUNDLES: {
    INE_BLACK_FRIDAY_BUNDLE_ONE,
    INE_BLACK_FRIDAY_BUNDLE_TWO,
    INE_BLACK_FRIDAY_BUNDLE_THREE,
  },
} = CONSTANTS

export default {
  name: 'PlanRowItemBlackFriday',
  mixins: [updateCart],
  props: {
    bundle: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      notIncluded: Object.values(PREMIUM_PLANS).includes(this.bundle.merchant_id),
      skillDiveLogoBadge: skillDiveLogo,
    }
  },
  components: {
    PlanListItemDetails,
    RadioButton,
  },
  computed: {
    ...mapState({
      isPremiumMonthlyPromoActive: state => state.app.isPremiumMonthlyPromoActive,
    }),
    isSelected() {
      return this.bundle.slug === this.selectedBundle.slug
    },
    isBestValue() {
      return this.bundle.slug === INE_BLACK_FRIDAY_BUNDLE_ONE
    },
    oneSkillDiveIncluded() {
      return this.bundle.slug === INE_BLACK_FRIDAY_BUNDLE_ONE
    },
    notIncludesSkillDive() {
      return this.bundle.slug === INE_BLACK_FRIDAY_BUNDLE_TWO
    },
    price() {
      return this.bundle.price_cents / 100
    },
    normalizedPlanName() {
      return this.bundle.nameToShow
    },
    includesPremium() {
      return !!this.bundle.products?.data?.filter(p => p.merchant_id === PREMIUM_PLANS.INE_PREMIUM)
        .length
    },
    includesSkillDive() {
      return !!this.bundle.products?.data?.filter(p => p.merchant_id === PLANS.SKILL_DIVE_ANNUAL)
        .length
    },
    includesCertification() {
      return [INE_BLACK_FRIDAY_BUNDLE_ONE, INE_BLACK_FRIDAY_BUNDLE_TWO].includes(this.bundle.slug)
    },
    includesFundAnnual() {
      return !!this.bundle.products?.data?.filter(p => p.merchant_id === PLANS.ANNUAL).length
    },
    isBundle1() {
      return this.bundle.slug === INE_BLACK_FRIDAY_BUNDLE_ONE
    },
    isBundle2() {
      return this.bundle.slug === INE_BLACK_FRIDAY_BUNDLE_TWO
    },
    isBundle3() {
      return this.bundle.slug === INE_BLACK_FRIDAY_BUNDLE_THREE
    },
    bundleName() {
      switch (true) {
        case this.isBundle1:
          return 'ADVENTURE 01'
        case this.isBundle2:
          return 'ADVENTURE 02'
        case this.isBundle3:
          return 'ADVENTURE 03'
        default:
          return 'ADVENTURE'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.bundle-row-item-bl {
  width: calc(100% - 14px);

  background: var(--glass-mid-gray);
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: all 1s ease-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  backdrop-filter: blur(30px);
  &:hover {
    background: var(--mid-gray-translucid-gradient);
  }
  &:active {
    transition: all 0.5s ease-out;
    background: var(--charcoal-gradient-two);
  }

  @include tablet {
    align-items: flex-start;
    padding-top: 0;
  }

  &__wrapper {
    &--best-value {
      margin-right: 14px;
    }
    position: relative;
    display: flex;
    width: 351px;
    flex-direction: column;
    align-items: flex-start;
    overflow: hidden;

    @include tablet {
      width: auto;
      overflow: unset;
      flex: 1 0 0;
    }

    .right-corner {
      background: var(--dark-brighter);
      width: 9px;
      height: 9px;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 2;
      mask: radial-gradient(9px at 0 100%, #0000 90%, #000);
    }

    .left-corner {
      background: var(--dark-brighter);
      width: 9px;
      height: 9px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      mask: radial-gradient(9px at 90% 100%, rgba(0, 0, 0, 0) 90%, #000);
    }
  }
  &--best-value {
    width: calc(100% - 14px);
    margin: 7px 0 0 7px;
    border-radius: 0;
  }
  &__price-wrapper {
    width: 200px;
    height: 100px;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    z-index: 1;
    @include mobile {
      height: 201px;
    }
    @include tablet {
      position: absolute;
      width: 100%;
      height: auto;
      display: flex;
      top: 7%;
      justify-content: center;
      align-items: center;
      &--best-value {
        top: 5%;
      }
    }
  }
  &__bundle-name {
    position: absolute;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--orange-gradient);
    width: 111px;
    height: 28px;
    padding: 7px;
    border-radius: 7px 0px 0px 0px;
    font-size: 12px;
    font-weight: 700;
  }
  &__price {
    color: var(--white, #fff);
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 54px;
    font-style: normal;
    font-weight: 700;
    line-height: 55px; /* 122.222% */
  }
  &__item-background {
    padding: 13px 40px 40px 40px;
    width: 100%;
    &--transparent {
      content: none;
      padding: 20px 40px 40px 40px;
      width: 100%;
    }
    @include tablet {
      position: relative;
      overflow: hidden;
    }
  }
  &__included {
    display: flex;
    height: auto;
    margin-top: 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
    align-self: stretch;
    @include mobile {
      height: 186px;
    }

    @include tablet {
      margin-top: 80px;
      z-index: 2;
      position: relative;
    }

    &__item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      max-width: 193px;
      text-align: center;
      &__title {
        font-size: rem(24px);
        font-style: normal;
        font-weight: 700;
        line-height: rem(32px); /* 133.333% */
      }
      &__subtitle {
        color: var(--purple-pale, #c9bbff);
        font-size: rem(12px);
        font-style: normal;
        font-weight: 450;
        line-height: rem(14px);
      }
      &:after {
        content: '+';
        height: 24px;
        color: var(--purple-pale, #c9bbff);
        font-size: 16px;
        font-style: normal;
        font-weight: 450;
        line-height: 24px; /* 150% */
      }
      &:last-child::after {
        content: none;
      }
    }
  }
  &--best-value-square {
    box-sizing: border-box;
    border-left: var(--dark-orchid);
    border-right: var(--majorelle-blue);
    border-top: var(--majorelle-blue);
    border-radius: 7px;
    border-bottom: transparent;
    border-width: 7px;
    border-style: solid;
    width: 100%;
    height: 99%;
    position: absolute;
    z-index: 0;
  }
  &__header {
    position: absolute;
    top: 0;
    left: 0px;
    height: 35px;
    width: 100%;
    background: var(--mid-gray-translucid-gradient-four);
    border-radius: 10px 10px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    &-text {
      text-align: center;
      font-size: rem(12px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(14px);
      display: flex;
      flex-flow: column;
      gap: 2px;
      @include tablet-ipad-air-and-mini-portrait {
        flex-flow: column;
      }
      @include tablet-ipad-pro {
        flex-flow: row;
      }
      @include desktop {
        flex-flow: row;
      }
    }
    &--best-value {
      background: var(--purple-gradient);
      left: -10px;
      width: calc(100% + 20px);
      .bundle-row-item__header-text {
        display: block;
      }
    }
  }
  &__title {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    @include mobile {
      height: 70px;
    }
    @include desktop {
      height: unset;
    }
  }
  &__bottom-content {
    position: absolute;
    width: 260px;
    height: 20px;
    right: 29.667px;
    text-align: right;
  }
  &__learn-more {
    &-link {
      color: var(--purple-pale);
      font-size: rem(14px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(20px);
      text-decoration: none;
    }
  }
  &__not-included {
    color: var(--light-blue-gray);
    font-size: rem(12px);
    font-style: italic;
    font-weight: 450;
    line-height: rem(14px);
  }
  &__radio-wrapper {
    position: absolute;
    width: 30px;
    height: 30px;
    right: 20px;
    top: 20px;
  }
  &__details {
    position: relative;
    z-index: 1;
    margin-bottom: 44px;
  }
  &__hr {
    max-width: 279.333px;
    width: 100%;
    height: 1px;
    margin: 30px 0;
    background: linear-gradient(
      112deg,
      rgba(187, 188, 199, 0.4) -46.39%,
      rgba(187, 188, 199, 0) 112.38%
    );
  }
  &__footer {
    &--best {
      width: calc(100% + 14px);
      margin-left: -7px;
    }
    display: flex;
    padding: 10px 15px;
    gap: 10px;
    min-height: 63px;
    align-self: stretch;
    border-radius: 0px 0px 10px 10px;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: 20px;
    border-radius: 0px 0px 10px 10px;
    background: var(
      --glass-extra-light,
      linear-gradient(112deg, rgba(187, 188, 199, 0.4) -46.39%, rgba(187, 188, 199, 0) 112.38%)
    );
    flex-direction: column;
    justify-content: center;
    flex: 1 0 0;
    align-self: stretch;

    background: var(
      --secondary-promo-purple,
      linear-gradient(97deg, #863ad2 7.05%, #5936e4 93.87%)
    );
    color: var(--secondary-purple-pale, #c9bbff);

    &--highlighted {
      color: var(--primary-ine-white, #fff);
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 25px;
    }
    &--purple {
      color: var(--secondary-purple-pale, #c9bbff);
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 14px;
    }
    &--small {
      color: var(--primary-ine-white, #fff);
      text-align: center;
      font-size: 12px;
      font-style: normal;
      font-weight: 450;
      line-height: 16px;
    }
  }
}
</style>
